export enum ENTETE_TABLEAU_LISTE_UTILISATEURS_ENUM {
	nom = 'Nom',
	prenom = 'Prénom',
	email = 'Email',
	droits = 'Droits'
}